import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme";
import { BrowserRouter } from "react-router-dom";
import store from "./redux/store";
import { Provider } from "react-redux";
import axios from "axios";
import AuthService from "./axios/auth.service";
import { original } from "@reduxjs/toolkit";
import { getUserDetails, updateUser } from "./redux/auth/AuthSlice";
import jwt_decode from "jwt-decode";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const REFRESH_TOKEN_ROUTE = "/api/user/refresh-accesstoken";
const notAccessRoutes = [
  "/api/user/refresh-accesstoken",
  "/api/user/signIn",
  "/api/user/otp-verify",
];

const client = new QueryClient();
let refreshing = false;

axios.interceptors.response.use(
  (successResponse) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return successResponse;
  },
  async (error) => {
    // // Any status codes that falls outside the range of 2xx cause this function to trigger
    const originalRequest = error.config;

    const urlObject = new URL(originalRequest.url);
    const route = urlObject.pathname;

    let errorResponse = error?.response;

    if (!notAccessRoutes.includes(route) && errorResponse) {
      if (errorResponse.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        if (!refreshing) {
          try {
            refreshing = true;
            const resp = await AuthService.refreshAccessToken();
            if (resp.status === "success") {
              // update the headers of axios
              const decodedUser = jwt_decode(resp.data);
              const userId = decodedUser?._id;
              store.dispatch(getUserDetails(userId));
              store.dispatch(updateUser(resp?.data));
              originalRequest.headers.Authorization = `Bearer ${resp.data}`;

              return axios(originalRequest).finally(() => {
                refreshing = false; // Reset the refresh status
              });
            } else {
              // clear localStorage if refresh token api call throw error with status code 401
              refreshing = false;
              if (resp.response.status === 401) {
                localStorage.clear();
                window.location.reload();
              }
              return Promise.reject(resp);
            }
          } catch (err) {
            refreshing = false;
            console.log(err, "err");
            localStorage.clear();
            window.location.reload();
            return Promise.reject(err);
          }
        }
      }
    }
    // clear localStorage if refresh token api call throw error with status code 401
    else if (
      route === REFRESH_TOKEN_ROUTE &&
      error.response &&
      error.response.status === 401
    ) {
      localStorage.clear();
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={client}>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <Provider store={store}>
            <App />
          </Provider>
        </BrowserRouter>
      </ChakraProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
